import '../../../assets/stylesheets/modal.css'
import '../../../assets/stylesheets/upload-modal.css'

const UploadProcessingModal = ({
  visible,
  message,
  successfulFilesCount,
  failedFilesCount,
  onClose,
  onGoToGallery
}) => {
  if (!visible) return null

  const TITLE = 'We are getting your files settled in'
  
  const rawMessage = message || ''
  const displayMessage = rawMessage.includes(TITLE)
    ? rawMessage.replace(TITLE, '').trim().replace(/^[:\-–—]\s*/, '')
    : rawMessage

  return (
    <div className={`upload-modal-overlay ${visible ? 'active' : ''}`} onClick={onClose}>
      <div className="upload-modal-window" onClick={e => e.stopPropagation()}>
        <h2 className="upload-modal-title">{TITLE}</h2>

        {displayMessage ? (
          (() => {
            const sentences = displayMessage.split(/(?<=[.?!])\s+/).map(s => s.trim()).filter(Boolean)
            return sentences.map((s, idx) => (
              <p key={idx} className="upload-modal-para">{s}</p>
            ))
          })()
        ) : (
          <>
            <p className="upload-modal-para">First time uploads may take a few minutes (or longer if you’ve got a LOT of stuff). That's just us rolling out the red carpet for your assets.</p>
            <p className="upload-modal-para">You can close Kinstak and come back later. Your beautifully organized assets will be ready and waiting. Future uploads? Lightning-fast!</p>
          </>
        )}

        <div className="upload-modal-buttons">
          <button className="upload-modal-btn upload-modal-btn--secondary" onClick={onClose}>Close</button>
          <button className="upload-modal-btn upload-modal-btn--primary" onClick={onGoToGallery}>Go to Gallery</button>
        </div>

        <div className="upload-modal-summary">
          <div>{successfulFilesCount > 0 ? `${successfulFilesCount} file(s) uploaded` : null}</div>
          {failedFilesCount > 0 && <div style={{ color: '#b00' }}>{failedFilesCount} failed</div>}
        </div>
      </div>
    </div>
  )
}

export default UploadProcessingModal
